import useBooleanConfig from './useBooleanConfig';

/** Gates every landlord-initiated tour entry point (right-rail card, in-thread nudge CTA) while the feature ships dark. */
export default function useManualTourSchedulingEnabled(): boolean {
  return useBooleanConfig('enableManualTourScheduling', false);
}
